/* eslint-disable @typescript-eslint/no-unused-vars */
import {IVideoConfig, TAspectRatioResponse} from './IAbstractVideo';

/**
 * Represents AbstractVideo
 */
abstract class AbstractVideo {
	protected readonly videoId: string;
	protected readonly aspectRatio: string;
	protected readonly thumbnail: string;

	/**
	 * Constructor
	 * @constructor
	 * @param {IVideoConfig} config - config
	 */
	protected constructor(config: IVideoConfig) {
		this.videoId = config.videoId;
		this.aspectRatio = config.aspectRatio;
		this.thumbnail = config.thumbnail;
	}

	/**
	 * Returns the video id
	 * @returns {string}
	 */
	getVideoId(): string {
		return this.videoId;
	}

	/**
	 * Returns the aspect ratio of the video
	 * @returns {string}
	 */
	getAspectRatio(): string {
		return this.aspectRatio;
	}

	/**
	 * Returns the video playback URL
	 * @returns {string}
	 */
	abstract getVideoUrl(): string;

	/**
	 * Returns the thumbnail url
	 */
	getThumbnailUrl(): string {
		if (this.thumbnail) {
			return this.thumbnail;
		}

		return null;
	}

	/**
	 * Returns the custom thumbnail URL if set, null otherwise.
	 */
	getCustomThumbnail(): string | null {
		return this.thumbnail || null;
	}

	/**
	 * Returns the original dimensions of the video selected by id
	 * @param {string} id - the id of the video
	 * @param {string} sessId - the session Id - needed for Thron API
	 */
	static async staticGetOriginalAspectRatio(id: string, sessId?: string): Promise<TAspectRatioResponse> {
		return null;
	}
}

export default AbstractVideo;
